/* eslint-disable no-console */
import { push } from 'connected-react-router';
import { apiLoja } from '@/services/api';
import * as ROUTES from '@/routes/routes';
import { showAlert } from '@/store/actions/theme';
import { translate } from '@/i18n/src/locales';
import * as _ from 'lodash';
import { fetchAllPolesCouponLoja } from './couponPoles';
import {
  COUPONS_SET,
  COUPON_EDIT_SET,
  COUPON_LOADING,
  COUPON_LOADED,
  COUPON_CLEAR,
  COUPON_PRODUCTS_SET,
  COUPON_PRODUCTS_LOADING,
  COUPON_PRODUCTS_LOADED,
} from '../actionTypes';

export const setCoupons = (coupons) => ({
  type: COUPONS_SET,
  payload: coupons,
});

export const setCouponEdit = (coupons) => ({
  type: COUPON_EDIT_SET,
  payload: coupons,
});

export const loadingCoupon = () => ({
  type: COUPON_LOADING,
});

export const loadedCoupon = () => ({
  type: COUPON_LOADED,
});

export const clearCoupon = () => ({
  type: COUPON_CLEAR,
});

export const setCouponProducts = (products, isProductsOnCoupon) => ({
  type: COUPON_PRODUCTS_SET,
  payload: { products, isProductsOnCoupon },
});

export const loadingCouponProducts = () => ({
  type: COUPON_PRODUCTS_LOADING,
});

export const loadedCouponProducts = () => ({
  type: COUPON_PRODUCTS_LOADED,
});

const getIdFranqueadoraFromState = (getState) => {
  const state = getState();
  return state.user.user.IdFranqueadora;
};

export const fetchCoupon = () => {
  return (dispatch, getState) => {
    dispatch(loadingCoupon());
    const IdFranqueadora = getIdFranqueadoraFromState(getState);

    apiLoja
      .get(`/Cupom/${IdFranqueadora}`)
      .then((data) => {
        dispatch(setCoupons(data.data));
        dispatch(loadedCoupon());
      })
      .catch((error) => {
        console.log('error comming', error);
      });
  };
};

export const addCoupon = (coupon) => {
  return (dispatch, getState) => {
    dispatch(loadingCoupon());
    const IdFranqueadora = getIdFranqueadoraFromState(getState);

    apiLoja
      .post(`/Cupom`, {
        ...coupon,
        IdFranqueadora,
      })
      .then((data) => {
        apiLoja
          .post(`/CupomFranqueadora`, {
            IdCupom: data.data.IdCupom,
            Ativo: false,
            IdCupomRecorrencia: coupon.IdCupomRecorrencia || 1,
            QtdeUso: coupon.QtdeUso || 0,
            IdFranqueadora,
          })
          .catch((err) => console.log('Erro ao adicionar cupom para franqueadora', err));

        dispatch(setCouponEdit(data.data));
        dispatch(loadedCoupon());
        dispatch(push(`${ROUTES.COUPON_CREATE}/${data.data.IdCupom}`));
        dispatch(
          showAlert({
            type: 'success',
            message: translate('couponAdd'),
            time: 3000,
          })
        );
      })
      .catch((error) => {
        if (error.response.status == 300) {
          dispatch(clearCoupon());
          dispatch(
            showAlert({
              type: 'warning',
              message: translate('couponExists'),
              time: 3000,
            })
          );
        } else if (error.response.status == 412) {
          dispatch(clearCoupon());
          dispatch(
            showAlert({
              type: 'warning',
              message: translate(error.response.data),
              time: 3000,
            })
          );
        } else console.log('error comming', error);
      });
  };
};

export const editCoupon = (coupon) => {
  return (dispatch, getState) => {
    dispatch(loadingCoupon());
    const IdFranqueadora = getIdFranqueadoraFromState(getState);

    apiLoja
      .put(`/Cupom`, {
        ...coupon,
        IdFranqueadora,
      })
      .then((data) => {
        apiLoja
          .put(`/CupomFranqueadora`, {
            IdCupom: coupon.idCupom,
            Ativo: coupon.AtivoFranqueadora !== undefined ? coupon.AtivoFranqueadora : false,
            IdCupomRecorrencia: coupon.IdCupomRecorrencia || 1,
            QtdeUso: coupon.QtdeUso || 0,
            IdFranqueadora,
          })
          .catch((err) => console.log('Erro ao atualizar cupom para franqueadora', err));

        dispatch(setCouponEdit(data.data));
        dispatch(push(`${ROUTES.COUPON_CREATE}/${coupon.idCupom}`));
        dispatch(loadedCoupon());
        dispatch(
          showAlert({
            type: 'success',
            message: translate('couponEdited'),
            time: 3000,
          })
        );
      })
      .catch((error) => {
        if (error.response.status == 412) {
          dispatch(clearCoupon());
          dispatch(
            showAlert({
              type: 'warning',
              message: translate(error.response.data),
              time: 3000,
            })
          );
        } else {
          console.log('error comming', error);
          dispatch(clearCoupon());
          dispatch(
            showAlert({
              type: 'warning',
              message: translate(error.response.data),
              time: 3000,
            })
          );
          setTimeout(() => {
            window.location.reload(true);
          }, 1000);
        }
      });
  };
};

export const releaseCouponToAll = (coupon) => {
  return (dispatch, getState) => {
    dispatch(loadingCoupon());
    const IdFranqueadora = getIdFranqueadoraFromState(getState);

    apiLoja
      .put(`/CupomFranqueadora`, {
        IdCupom: coupon.idCupom,
        Ativo: coupon.Ativo !== undefined ? coupon.Ativo : false,
        IdCupomRecorrencia: coupon.IdCupomRecorrencia || 1,
        QtdeUso: coupon.QtdeUso || 0,
        IdFranqueadora,
      })
      .then((data) => {
        dispatch(setCouponEdit(data.data));
        dispatch(push(`${ROUTES.COUPON_CREATE}/${coupon.idCupom}`));
        dispatch(loadedCoupon());
        dispatch(
          showAlert({
            type: 'success',
            message: 'Cupom liberado para todos com sucesso!',
            time: 3000,
          })
        );
        dispatch(fetchAllProductsCouponLoja(coupon.idCupom));
        dispatch(fetchAllPolesCouponLoja(coupon.idCupom));
      })
      .catch((error) => {
        if (error.response && error.response.status == 412) {
          dispatch(clearCoupon());
          dispatch(
            showAlert({
              type: 'warning',
              message: translate(error.response.data),
              time: 3000,
            })
          );
        } else {
          console.log('error comming', error);
          dispatch(clearCoupon());
          dispatch(
            showAlert({
              type: 'warning',
              message: error.response && error.response.data ? translate(error.response.data) : 'Erro ao liberar cupom',
              time: 3000,
            })
          );
          setTimeout(() => {
            window.location.reload(true);
          }, 1000);
        }
      });
  };
};

export const fetchAllCouponLoja = () => {
  return (dispatch, getState) => {
    dispatch(loadingCoupon());
    const IdFranqueadora = getIdFranqueadoraFromState(getState);

    apiLoja
      .get(`/Cupom/Franqueadora/${IdFranqueadora}`)
      .then((data) => {
        dispatch(setCoupons(data.data));
        dispatch(loadedCoupon());
      })
      .catch((error) => {
        console.log('error comming', error);
      });
  };
};

export const fetchCouponById = (IdCupom) => {
  return (dispatch, getState) => {
    dispatch(loadingCoupon());
    const IdFranqueadora = getIdFranqueadoraFromState(getState);

    apiLoja
      .get(`/Cupom/${IdCupom}`)
      .then((data) => {
        // Busca os dados complementares da franqueadora para o cupom
        apiLoja
          .get(`/CupomFranqueadora/${IdFranqueadora}/${IdCupom}`)
          .then((franqueadoraData) => {
            const merged = { ...data.data };
            if (franqueadoraData.data) {
              merged.AtivoFranqueadora = franqueadoraData.data.Ativo;
              merged.IdCupomRecorrencia = franqueadoraData.data.IdCupomRecorrencia;
              merged.QtdeUso = franqueadoraData.data.QtdeUso;
            } else {
              merged.AtivoFranqueadora = false;
            }
            dispatch(setCouponEdit(merged));
            dispatch(loadedCoupon());
          })
          .catch((err) => {
            console.log('Erro ao buscar CupomFranqueadora', err);
            // Fallback caso não encontre ou dê erro na rota de franqueadora
            dispatch(setCouponEdit(data.data));
            dispatch(loadedCoupon());
          });
      })
      .catch((error) => {
        console.log('error comming', error);
      });
  };
};

export const fetchAllProductsCouponLoja = (IdCupom) => {
  return (dispatch, getState) => {
    dispatch(loadingCouponProducts());
    const IdFranqueadora = getIdFranqueadoraFromState(getState);

    apiLoja
      .get(`/CupomProduto/${IdCupom}/Franqueadora/${IdFranqueadora}`)
      .then((data) => {
        if (data.data) {
          const ordered = _.orderBy(data.data, 'Vinculado', 'desc');

          const isProductOnCoupon = _.find(ordered, { Vinculado: true }) || false;

          if (isProductOnCoupon) {
            dispatch(setCouponProducts(ordered, true));
          } else {
            dispatch(setCouponProducts(ordered, false));
          }
        }

        dispatch(loadedCouponProducts());
      })
      .catch((error) => {
        console.log('error comming', error);
      });
  };
};

export const addCouponProduct = (vinculado) => {
  return (dispatch) => {
    dispatch(loadingCouponProducts());
    apiLoja
      .post(`/CupomProduto`, {
        ...vinculado,
      })
      .then(() => {
        dispatch(fetchAllProductsCouponLoja(vinculado.IdCupom));
      })
      .catch((error) => {
        console.log('error comming', error);
      });
  };
};

export const updateCouponProduct = (vinculado) => {
  return (dispatch) => {
    dispatch(loadingCouponProducts());
    apiLoja
      .put(`/CupomProduto`, {
        ...vinculado,
      })
      .then((data) => {
        dispatch(fetchAllProductsCouponLoja(vinculado.IdCupom));
      })
      .catch((error) => {
        console.log('error comming', error);
      });
  };
};

export const fetchCouponProductsLoja = (cupomProduto) => {
  return (dispatch) => {
    cupomProduto.Ativo = true;
    dispatch(loadingCouponProducts());
    apiLoja
      .get(`/CupomProduto/${cupomProduto.IdCupom}/${cupomProduto.IdProduto}`)

      .then((data) => {
        if (data.data) {
          dispatch(updateCouponProduct(cupomProduto));
        } else {
          dispatch(addCouponProduct(cupomProduto));
        }
        dispatch(loadedCouponProducts());
      })
      .catch((error) => {
        console.log('error comming', error);
      });
  };
};
